import React from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
const Icon = ({ large = false, style, name, dataCy }) => (React.createElement("i", { className: classNames(midas.icon, midas[name], large && midas.largeIcon), style: style, "data-cy": dataCy }));
export default Icon;
